export const checkTabPage = (tab) => {
  switch (tab) {
    case "cut-list":
      return 150;
    case "optimize":
      return -1;
    case "used-items":
      return 210;
    case "quality-control":
      return 230;
    default:
      return null;
  }
};